<template>
    <v-card v-if="graphData" height="100%">
      <v-card-title primary-title>
        <div class="title">{{title}}</div>
      </v-card-title>
      <v-card-text v-if="graphData">
        <v-layout row wrap>
          <v-flex xs4><strong>{{labels[0]}}</strong></v-flex>
          <v-flex xs4><strong>{{labels[1]}}</strong></v-flex>
          <v-flex xs4><strong>%</strong></v-flex>
        </v-layout>
        <v-divider></v-divider>
        <template v-for="(item, index) in graphData">
          <v-layout row wrap v-bind:key="index">
            <v-flex xs4>{{item.name}}</v-flex>
            <v-flex xs4>{{item.total}}</v-flex>
            <v-flex xs4>{{item.percentage}} %</v-flex>
          </v-layout>
          <v-divider v-bind:key="`divider-${index}`"></v-divider>
        </template>
        <aux-chart class="aux-chart" :chartdata="graphData"></aux-chart>
      </v-card-text>
    </v-card>
</template>
<script>
import AuxChart from './AuxChart';

export default {
  components: {
    'aux-chart' : AuxChart,
  },
  name : 'card-aux',
  props : ['labels', 'title', 'graphData'],
  data () {
    return {
      
    };
  },
  created: function() { 
    
  },
  methods: {
    
  }
};
</script>
<style scoped lang="css">
  .aux-chart {
    margin-top: 10px;
    position: relative;
    height: 250px;
  }

</style>
